var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Title, Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment-wrapper';
var MetaTagService = /** @class */ (function () {
    function MetaTagService(titleService, metaTagService, translateService, document) {
        this.titleService = titleService;
        this.metaTagService = metaTagService;
        this.translateService = translateService;
        this.document = document;
        this._domain = environment.cdnServerUrl.slice(0, -1); // Remove the trailing slash
    }
    MetaTagService.prototype.setPageTitle = function (translationName, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._formatVariableData(variables)];
                    case 1:
                        variables = _a.sent();
                        this.translateService.get(translationName, variables).toPromise().then(function (title) { return _this.titleService.setTitle(title); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MetaTagService.prototype.setPageDescription = function (translationName, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._formatVariableData(variables)];
                    case 1:
                        variables = _a.sent();
                        this.translateService.get(translationName, variables).toPromise().then(function (description) { return _this.metaTagService.updateTag({ name: 'description', content: description }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Use this to set the relevant Open Graph Tags if necessary
     * @param variables an array of the open graph tags we want to set
     */
    MetaTagService.prototype.setOpenGraphTags = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _loop_1, this_1, _i, variables_1, tag;
            return __generator(this, function (_a) {
                if (!variables)
                    return [2 /*return*/];
                _loop_1 = function (tag) {
                    var name_1 = (tag.prefixName || 'og') + ':' + tag.name;
                    if (tag.isTranslateKey) {
                        this_1.translateService.get(tag.content, tag.variables).toPromise().then(function (description) { return _this.metaTagService.updateTag({ property: name_1, content: description }); });
                    }
                    else if (tag.name === 'url')
                        this_1.metaTagService.updateTag({ property: name_1, content: this_1._domain + tag.content });
                    else
                        this_1.metaTagService.updateTag({ property: name_1, content: tag.content });
                };
                this_1 = this;
                for (_i = 0, variables_1 = variables; _i < variables_1.length; _i++) {
                    tag = variables_1[_i];
                    _loop_1(tag);
                }
                return [2 /*return*/];
            });
        });
    };
    MetaTagService.prototype._formatVariableData = function (variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!variables) return [3 /*break*/, 3];
                        if (!variables['province']) return [3 /*break*/, 2];
                        _a = variables;
                        _b = 'province';
                        return [4 /*yield*/, this.translateService.get('provinces.' + variables['province']).toPromise()];
                    case 1:
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2:
                        if (variables['city'])
                            variables['city'] = variables['city'].charAt(0).toUpperCase() + variables['city'].slice(1);
                        if (variables['propType'])
                            variables['propType'] = variables['propType'].charAt(0).toUpperCase() + variables['propType'].slice(1);
                        _c.label = 3;
                    case 3: return [2 /*return*/, variables];
                }
            });
        });
    };
    return MetaTagService;
}());
export { MetaTagService };
var OpenGraphTag = /** @class */ (function () {
    function OpenGraphTag() {
        this.prefixName = 'og'; // When we want to use a prefix thats not for open graph
    }
    return OpenGraphTag;
}());
export { OpenGraphTag };
